import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

type AvatarProps = HTMLAttributes<HTMLDivElement> & {
  fallback: string;
};

export function Avatar({ className, fallback, ...props }: AvatarProps) {
  return (
    <div
      className={cn(
        "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary text-sm font-semibold text-secondary-foreground",
        className,
      )}
      {...props}
    >
      {fallback.slice(0, 2).toUpperCase()}
    </div>
  );
}
